import { FormValues } from '@topdanmark-onlinesolutions/claim-form-types';

export const validateNumberOfFiles = (value: FormValues, minFiles: number, maxFiles: number | undefined): boolean => {
    if (value !== undefined && value.files !== undefined && Array.isArray(value.files)) {
        const numberOfFiles = value.files.length;
        return numberOfFiles >= minFiles && (maxFiles !== undefined ? numberOfFiles <= maxFiles : true);
    }
    return false; // If value is not an array, validation fails
};
